import { IDataType, IProjectInfo } from '@/store/models/tableEdit.model'


export const dataSource1: IDataType[] = [
    {
        key: '1',
        name: '',
        workgroup: 'WG1 Services and Application',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_gray'
    },
    {
        key: '2',
        name: '技术名称 Tech Name',
        workgroup: 'Data storage capacity extension support',
        '2021': '支持TB级别数据量（Support TB level Data）',
        '2022': '支持PB级别数据量（Support PB level Data）',
        '2023': '支持EB级别数据量（Support EB level Data）',
        className: 'bg_1'
    },
    {
        key: '3',
        name: '技术编号 PTN',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_1'
    },
    {
        key: '4',
        name: '技术项目名 Project Info',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_1'
    },
    {
        key: '5',
        name: '达成状态 Released',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_1'
    },
    {
        key: '6',
        name: '技术名称 Tech Name',
        workgroup: 'Support data of closed loop algorithm',
        '2021': '预标注等关键模块实现 Pre marked key modules such as implementation',
        '2022': '',
        '2023': '',
        className: 'bg_2'
    },
    {
        key: '7',
        name: '技术编号 PTN',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_2'
    },
    {
        key: '8',
        name: '技术项目名 Project Info',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_2'
    },
    {
        key: '9',
        name: '达成状态 Released',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_2'
    },
    {
        key: '10',
        name: '技术名称 Tech Name',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_3'
    },
    {
        key: '11',
        name: '技术编号 PTN',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_3'
    },
    {
        key: '12',
        name: '技术项目名 Project Info',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_3'
    },
    {
        key: '13',
        name: '达成状态 Released',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_3'
    },
    {
        key: '14',
        name: '技术名称 Tech Name',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_4'
    },
    {
        key: '15',
        name: '技术编号 PTN',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_4'
    },
    {
        key: '16',
        name: '技术项目名 Project Info',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_4'
    },
    {
        key: '17',
        name: '达成状态 Released',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_4'
    },
    {
        key: '18',
        name: '技术名称 Tech Name',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_5'
    },
    {
        key: '19',
        name: '技术编号 PTN',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_5'
    },
    {
        key: '20',
        name: '技术项目名 Project Info',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_5'
    },
    {
        key: '21',
        name: '达成状态 Released',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': '',
        className: 'bg_5'
    },
]

export const dataSource2: IProjectInfo[] = [
    {
        id: 1,
        version: 0,
        techClassId: 1,
        classificationName: '微服务 Micro Service',
        techPtn: 'PTNSNA21001',
        researchForms: 'TECH PRJ',
        techName: '服务治理;Micro Service Management',
        subsidiary: '',
        description: '•微服务注册与发现; Service Register and Discovery by Eureka Server;•服务容错保护; Service Fault Tolerance Protection;•声明式服务调用与负载均衡; Declarative Service Invocation and Load Balance',
        techLevel: 1,
        priority: 'HIGH',
        '21-Q1': 'ON',
        '21-Q2': 'ON',
        '21-Q3': 'ON',
        '21-Q4': 'ON',
        tmtapproval: 'NA',
        maturity: 'DEVELOPING',
        requirementSource: 'MARKET INSIGHT/TECH INFO LIST',
        developedBy: '黄守义',
        buStakeholder: 'IOV，KAWA，CT',
        toolsAndEquipment: '服务器',
        resourceNeeded: 30,
        quantitativeIndicators: '',
        toolsEquipment: '',
        techYearQuarters: []
    },
    {
        id: 2,
        version: 0,
        techClassId: 2,
        classificationName: '微服务 Micro Service',
        techPtn: 'PTNSNA21002',
        researchForms: 'TECH PRJ',
        techName: '服务治理;Micro Service Management',
        subsidiary: '',
        description: '•微服务注册与发现; Service Register and Discovery by Eureka Server;•服务容错保护; Service Fault Tolerance Protection;•声明式服务调用与负载均衡; Declarative Service Invocation and Load Balance',
        techLevel: 1,
        priority: 'HIGH',
        '22-Q1': 'PLAN',
        '22-Q2': 'PLAN',
        '22-Q3': 'PLAN',
        '22-Q4': 'PLAN',
        tmtapproval: 'NA',
        maturity: 'DEVELOPING',
        requirementSource: 'MARKET INSIGHT/TECH INFO LIST',
        developedBy: '黄守义',
        buStakeholder: 'IOV，KAWA，CT',
        toolsAndEquipment: '服务器',
        resourceNeeded: 30,
        quantitativeIndicators: '',
        toolsEquipment: '',
        techYearQuarters: []
    },
]
